import CustomCheckbox from "../../../shared/components/custom-checkbox/custom-checkbox";
import { IColumn } from "../data-table/data-table";

export interface IColumnSelector {
  availableColumns: IColumn[];
  selectedColumns: IColumn[];
  onSelectionChanged: (selectedColumns: IColumn[]) => void;
}

const ColumnSelector = ({availableColumns, selectedColumns, onSelectionChanged}: IColumnSelector) => {
  const handleOnSelectColumn = (id: string, role: string, status: boolean) => {
    let newColumns: IColumn[] = [];
    if (status) {
      const selectedColumn = availableColumns.find(column => column.key === id);
      if (selectedColumn) {
        newColumns = [...selectedColumns, selectedColumn];
      }
    } else {
      newColumns = selectedColumns.filter((column) => column.key !== id);
    }
    onSelectionChanged(newColumns);
  };

  return <div className="columnSelector">                    
    {availableColumns.map((column, i) => (
      <CustomCheckbox
        simple={true}
        key={i}
        handleOnSelectRole={handleOnSelectColumn}
        id={column.key} 
        text={column.displayName}
        initialValue={selectedColumns.some(c => c.key === column.key)}
      />
    ))}
  </div>;
};

export default ColumnSelector;
